import { createReducer } from '@reduxjs/toolkit'
import { ICoursesPack } from 'shared/types'
import { receiveCoursesPacks } from 'model/actions'

const initialState = null as Record<string, ICoursesPack> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveCoursesPacks, (state, action) => action.payload)
})

export default reducer
